import styled from 'styled-components'

import { theme } from 'styles/theme'

import { CARD_GAP, fluidType } from '../fluid-type'

const { colors, media, space } = theme

export { Section } from 'components/general-styles/General'

export const TitleWrapper = styled.div`
  h2 {
    margin: 0;
    font-size: ${fluidType.sectionTitle};
    letter-spacing: -0.02em;
  }
`

export const Lead = styled.div`
  margin-top: ${space['spacing-xl']};

  p {
    margin: 0;
  }

  @media (${media.desktop}) {
    margin-top: 3.125rem;
  }
`

export const Cards = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space['spacing-md']};
  margin-top: ${space['spacing-xl']};

  @media (${media.tablet}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (${media.desktop}) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: ${CARD_GAP};
    margin-top: 3.125rem;
  }
`

/* Medidas do desenho (nó 4139:9767): 40px em cima e embaixo, 30px nas
   laterais, e 30px entre o título e o texto — o corpo começa em y=95. O gap
   era spacing-xl (40px), que empurrava o corpo para 105 e alongava o card;
   a lateral era spacing-lg (32px), 2px além do desenho. A escala de
   espaçamento pula de 24px para 32px, daí o valor fixo. */
export const Card = styled.article`
  display: flex;
  flex-direction: column;
  gap: 1.875rem;
  padding: ${space['spacing-xl']} 1.875rem;
  overflow: hidden;
  background-color: ${colors['neutral-background-contrast']};

  /* 20px do desenho: a escala de raio pula de 16px para 24px. */
  border-radius: 1.25rem;

  p {
    margin: 0;
  }
`
